import { Component } from '@angular/core';

import { SidebarService } from '@layout/core/services';
import { CurrentUserService } from '@core/services';
import { CurrentUser } from '@shared/interfaces';
import { ToasterPositionEnum } from '@shared/enums';
import { MixpanelService } from '@core/services/mixpanel.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    isSidebarCollapsed: boolean = true;
    isLoading: boolean = true;
    hasError: boolean = false;
    currentUser: CurrentUser | null = null;
    toasterPositions = ToasterPositionEnum;

    isUnauthorized: boolean = false;

    constructor(
        private sidebarService: SidebarService,
        private currentUserService: CurrentUserService,
        private mixpanel: MixpanelService
    ) {
        this.mixpanel.init();

        this.sidebarService.isCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isSidebarCollapsed = isCollapsed;
        });

        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser = user;
            this.isLoading = false;
        });

        this.currentUserService.isUnauthorized$.subscribe(value => {
            this.isUnauthorized = value;
            this.currentUser = null;
            this.isLoading = false;
        });
    }
}
